import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import ModifyReport from '../../containers/reports/ModifyReport'

class PReportModify extends React.Component<RouteComponentProps<{ customerId: string, id: string}>> {
    render() {
        const { customerId, id } = this.props.match.params
        const back = `/admin/customers/${customerId}`
        return (
            <React.Fragment>
               
                <ModifyReport
                    customerId={customerId}
                    id ={+id}
                    back={back}
                    onSuccess={() => this.props.history.push(back) }
                />
            </React.Fragment>
        )
    }
}

export default PReportModify
